import angular from 'angular';
import template from './template.html';

export class EmployerActivityReportCsvExport {
    csvData = {
        fileName: '',
        headers: [],
        columns: [],
    };

    /* @ngInject */
    constructor(EmployerActivityReportService, Logger, PositionReportService) {
        this.employerActivityReportService = EmployerActivityReportService;
        this.logger = Logger;
        this.positionReportService = PositionReportService;
    }

    $onInit() {
        this.setupCsv(this.employerName)
    }

    setupCsv(employerName) {
        this.csvData = this.employerActivityReportService.getCvsMetadata(employerName);
    }

    async exportActivityReports() {
        try {
            const {result: reports} = await this.positionReportService.getEmployerActivityReport({
                employerId: this.employerId,
            });

            return this.employerActivityReportService.getCsvContent(reports);

        } catch (err) {
            this.logger.error(err);
        }
    }
}

export const EmployerActivityReportCsvExportConfiguration = {
    template,
    bindings: {
        employerId: '<',
        employerName: '<',
    },
    controller: EmployerActivityReportCsvExport,
    controllerAs: 'employerActivityReportCsvExportCtrl'
};

angular
    .module('TALENYA-FE')
    .component('employerActivityReportCsvExport', EmployerActivityReportCsvExportConfiguration);
